// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1d-0";
export var spinnerContainer = "_1d-1";